const CaretRightIconFor2ndPageDimension = () => {
   function cartDimension(){

   }
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="CaretRightIconFor2ndPageDimension"
        id="CaretRightIconFor2ndPageDimensionId"
        onClick={cartDimension}

        style={{
            width: "24px",
            height: "24px",
            background: "white",
            borderRadius: "50rem",
            padding: "0.1rem",
          }}
      
          fill="#ffffff"
          viewBox="0 0 256 256"
        >
          <rect width="256" height="256" fill="none"></rect>
          <polyline
            points="96 48 176 128 96 208"
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="16"
        ></polyline>
      </svg>
    );
  };
  export default CaretRightIconFor2ndPageDimension;
  